/**
 * Preview feature constants.
 * Must match GraphQL PreviewFeature enum.
 */
export const PreviewFeature = {
    /** New Workspace 2.0 feature */
    NEW_WORKSPACE_20: 'NEW_WORKSPACE_20',
    /** Level of Specification Automation feature */
    LOS_AUTOMATION: 'LOS_AUTOMATION',
    /** Product Type Automation feature */
    PT_AUTOMATION: 'PT_AUTOMATION',
    /** Drawing Designation feature */
    DRAWING_DESIGNATION: 'DRAWING_DESIGNATION',
    /** Sustainability Automation feature */
    SUSTAINABILITY_AUTOMATION: 'SUSTAINABILITY_AUTOMATION',
    /** Key Modification Warning feature */
    KEY_MODIFICATION: 'KEY_MODIFICATION',
} as const

/** Type for preview feature values */
export type PreviewFeature = typeof PreviewFeature[keyof typeof PreviewFeature]
